import { DealType } from 'utils/entities';
import { invert } from 'lodash';
import { Amenity } from 'components/filters/types';

export const dealTypeDict: Record<string, DealType> = {
  'rent': DealType.Rent,
  'sale': DealType.Buy,
};

export const amenitiesDict: Record<string, Amenity> = {
  'doorman': Amenity.Doorman,
  'laundry': Amenity.UnitLaundry,
  'pets-friendly': Amenity.UnitPetsAllowed,
  'dishwasher': Amenity.Dishwasher,
  'furnished': Amenity.Furnished,
  'fireplace': Amenity.Fireplace,
  'heating': Amenity.Heating,
  'loft': Amenity.Loft,
  'outdoor-space': Amenity.OutdoorSpace,
  'garage': Amenity.Garage,
  'gym': Amenity.Gym,
  'building-laundry': Amenity.BuildingLaundry,
  'pool': Amenity.Pool,
  'smoke-free': Amenity.SmokeFree,
  'roofdeck': Amenity.Roofdeck,
  'parking': Amenity.Parking,
  'balcony': Amenity.Balcony,
  'secure-room': Amenity.SecureRoom,
  'accessible': Amenity.Accessible,
  'grating': Amenity.Grating,
  'elevator': Amenity.Elevator,
  'air-conditioner': Amenity.AirConditioner,
  'storage': Amenity.Storage,
  'basement': Amenity.Basement,
  'attic': Amenity.Attic,
};


export const dealTypeInvertedDict = invert(dealTypeDict);
export const amenitiesInvertedDict = invert(amenitiesDict);
